import React, {useCallback} from 'react';

// GLOBAL FUNCTIONS
import { debounce, doCallback } from 'functions';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// STYLES
//import styles from './searchFilter.module.scss';

// MAIN COMPONENT
const SearchFilter = ({
  name = 'searchString', 
  onUpdate,
  ...props
}) => {

  // CALLBACKS
  const handleChange = useCallback(
    e => {
      doCallback(onUpdate, {[e.target.name]: e.target.value})
    },
    [onUpdate]
  )
  const handleClear = useCallback(
    () => {
      doCallback(onUpdate,{[name] : undefined})
    },
    [name, onUpdate]
  )

  // RENDER
  return (
    <Form.Control
      name={name}
      label="Keyword Search"
      placeholder="Search by keyword"
      onChange={debounce(handleChange)}
      onClear={handleClear}
      clearButton
      {...props}
    />
  )
}

// EXPORT
export default SearchFilter;
